<div *ngIf="apiLoaded" class="complaint-map">
    <google-map
        height="800"
        width="100%"
        [zoom]="mapZoom"
        [center]="mapCenter"
        [options]="{ mapId: 'DEMO_MAP_ID_2' }"
        #complaintsMap
        (centerChanged)="onCenterChanged()"
        (zoomChanged)="onZoomChanged()"
    >
    </google-map>
</div>

<ng-template
    #infoWindowTemplate let-complaintAppointment="data"
    >
    <div class="complaint-info">
        <div class="complaint-info__details">
            <div class="complaint-info__row">
                <span class="complaint-info__label">{{ 'COMPLAINT_APPOINTMENT|Nr wizyty:' | translate }}</span>
                <span class="complaint-info__data" *ngIf="complaintAppointment?.documentNumber">{{ complaintAppointment?.documentNumber ? complaintAppointment?.documentNumber.join('') : '' }} #{{ complaintAppointment?.internalIndex }}</span>
            </div>
            <div class="complaint-info__row">
                <span class="complaint-info__label">{{ 'COMPLAINT|Klient:' | translate }}</span>
                <span class="complaint-info__data">
                    {{ complaintAppointment?.clientName }}
                    <br>
                    <small *ngIf="complaintAppointment?.installationAddress" >
                        {{ complaintAppointment?.installationAddress }}
                    </small>
                </span>
            </div>
            <div class="complaint-info__row">
                <span class="complaint-info__label">{{ 'COMPLAINT_APPOINTMENT|Planowana data wizyty:' | translate }}</span>
                <span class="complaint-info__data" *ngIf="complaintAppointment.date">
                    {{ complaintAppointment.date | date: 'shortDate' }}
                </span>
                <span class="complaint-info__data" *ngIf="!complaintAppointment.date">
                    {{ 'INTERFACE|Brak' | translate }}
                </span>
            </div>
            <div class="complaint-info__row">
                <span class="complaint-info__label">{{ 'COMPLAINT_APPOINTMENT|Przypisanie:' | translate }}</span>
                <span class="complaint-info__data">{{ complaintAppointment?.companyName ? complaintAppointment?.companyName : 'INTERFACE|Brak' | translate }}</span>
            </div>
            <div class="complaint-info__row">
                <span class="complaint-info__label">{{ 'COMPLAINT_APPOINTMENT|Pracownik:' | translate }}</span>
                <span class="complaint-info__data">{{ complaintAppointment?.assignedUserId ? getWorkerName(complaintAppointment.assignedUserId) : 'INTERFACE|Brak' | translate }}</span>
            </div>
            <div class="complaint-info__row">
                <span class="complaint-info__label">{{ 'COMPLAINT_APPOINTMENT|Wykorzystany czas/planowany czas:' | translate }}</span>
                <span class="complaint-info__data">
                    <ng-container *ngIf="complaintAppointment.timeUsed">{{ complaintAppointment.timeUsed }} min</ng-container>
                    <ng-container *ngIf="!complaintAppointment.timeUsed">{{ 'INTERFACE|Brak' | translate }}</ng-container> /
                    <ng-container *ngIf="complaintAppointment.scheduledTime">{{ complaintAppointment.scheduledTime }} min</ng-container>
                    <ng-container *ngIf="!complaintAppointment.scheduledTime">{{ 'INTERFACE|Brak' | translate }}</ng-container>
                </span>
            </div>
            <div class="complaint-info__row">
                <span class="complaint-info__label">{{ 'COMPLAINT_APPOINTMENT|Status:' | translate }}</span>
                <span *ngIf="complaintAppointment.status" class="appointment-card__status">
                    <icc-appointment-status [status]="complaintAppointment.status"></icc-appointment-status>
                </span>
            </div>
          <button iccButton appearance="secondary" (click)="open(complaintAppointment.documentId, complaintAppointment.uuid)" class="complaint-info__button">
            {{ 'INTERFACE|Otwórz' | translate }} <icc-icon name="navigate_next"></icc-icon>
          </button>
        </div>
      </div>
  </ng-template>
